import { useCallback } from "react";

const useAutoFocus = (scroll) => {
	return useCallback(e => {setTimeout(() => e?.focus({preventScroll: !!scroll}), 10)}, []);
};

export default useAutoFocus;
